import _ from 'lodash';
import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.emailTo',
    modules: [
        R,
    ],
})
@Service('EmailToStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('email-to');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/emailto.js